import b from 'b_';
import { TrashClearKit, Document } from 'education-icons';
import {
    Button,
    Link,
    Popup,
    showIntlMessageNotification,
    SimpleCallback,
    SimpleText,
    ThreeDots,
} from 'platform-components';
import { GRAVITIES, NOTIFICATION_THEMES, POPUP_DIRECTIONS } from 'platform-components/constants';
import React, { useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ym from 'react-yandex-metrika';

import { COMMON_NOTIFICATION_DELAY } from 'common.components/constants';
import { actions as lessonActions } from 'common.components/lesson';
import * as lessonSelectors from 'common.components/lesson/selectors';

import { actions as lessonWidgetActions } from '../actions';

import './lesson-editor-widget__dots-menu.scss';

interface Props {
    onDelete: SimpleCallback;

    /**
     * Нужно ли отключить сохранение в черновики
     */
    disableDrafts?: boolean | undefined;
}

const LessonEditorDotsMenu = ({ onDelete, disableDrafts }: Props) => {
    const dispatch = useDispatch();
    const threeDotsRef = useRef<Popup | null>(null);
    const cLessonId = useSelector(lessonSelectors.getCLessonId);

    const setPopupRef = (ref: Popup | null) => {
        threeDotsRef.current = ref ? ref : null;
    };

    const saveLesson = () => {
        threeDotsRef.current?.hide();

        ym('reachGoal', 'teacher_lesson_creation_editorpreview_save_draft', {
            clessonId: cLessonId,
        });

        dispatch(
            showIntlMessageNotification({
                closeDelay: COMMON_NOTIFICATION_DELAY,
                gravity: GRAVITIES.BOTTOM,
                messageId: 'lesson.clessonDraftIsSavedToast',
                theme: NOTIFICATION_THEMES.TOAST,
            })
        );

        dispatch(lessonActions.clearEditor());
        dispatch(lessonWidgetActions.toggleLessonWidget(false));
    };

    return (
        <ThreeDots
            direction={POPUP_DIRECTIONS.LEFT}
            mix={b('lesson-editor-widget', 'dots-menu-control')}
            popupProps={{
                mix: 'lesson-editor-widget__dots-menu-popup',
                inLayer: false,
                ref: setPopupRef,
                fitToScreen: true,
            }}
            view={ThreeDots.VIEWS.CLEAR}
        >
            {!disableDrafts && (
                <ThreeDots.Item key="dotsMenu.saveLesson" type={ThreeDots.TYPES.PLAIN} withBorder={false}>
                    <Link mix="qa_save-lesson-link" onClick={saveLesson} pseudo>
                        <Button icon={<Document />} view={Button.VIEW.CLEAR}>
                            <SimpleText id="lessonEditorWidget.dotsMenu.saveLesson" />
                        </Button>
                    </Link>
                </ThreeDots.Item>
            )}
            <ThreeDots.Item key="dotsMenu.deleteLesson" type={ThreeDots.TYPES.PLAIN} withBorder={true}>
                <Link mix="qa_delete-lesson-link" onClick={onDelete} pseudo>
                    <Button accent={Button.ACCENT.DANGER} icon={<TrashClearKit />} view={Button.VIEW.CLEAR}>
                        <SimpleText id="lessonEditorWidget.dotsMenu.deleteLesson" />
                    </Button>
                </Link>
            </ThreeDots.Item>
        </ThreeDots>
    );
};

export default LessonEditorDotsMenu;
